import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Bell, Search, Menu } from "lucide-react";

export default function Topbar({
  title,
  subtitle,
  onToggleSidebar,
  rightSlot,
}) {
  return (
    <div className="sticky top-0 z-20 bg-white/75 backdrop-blur-md border-b border-slate-200">
      <div className="px-6 py-4 flex items-center gap-4">
        <button
          onClick={onToggleSidebar}
          className="hidden lg:inline-flex items-center justify-center w-9 h-9 rounded-lg text-slate-500 hover:text-cct-blue hover:bg-slate-100"
        >
          <Menu className="w-5 h-5" />
        </button>
        <div className="min-w-0 flex-1">
          <AnimatePresence mode="wait">
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.25 }}
            >
              <h1 className="font-display text-xl sm:text-2xl font-semibold text-slate-900 truncate">
                {title}
              </h1>
              {subtitle && (
                <p className="text-xs sm:text-sm text-slate-500 truncate">
                  {subtitle}
                </p>
              )}
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="hidden md:flex items-center gap-2 bg-slate-100 rounded-lg px-3 py-1.5 w-72">
          <Search className="w-4 h-4 text-slate-400" />
          <input
            placeholder="Search..."
            className="bg-transparent outline-none text-sm flex-1 text-slate-700 placeholder-slate-400"
          />
        </div>
        <button className="relative inline-flex w-9 h-9 items-center justify-center rounded-lg text-slate-500 hover:text-cct-blue hover:bg-slate-100">
          <Bell className="w-5 h-5" />
          <span className="absolute top-2 right-2 w-2 h-2 rounded-full bg-[#C49A3A] ring-2 ring-white" />
        </button>
        {rightSlot}
      </div>
    </div>
  );
}
